import { useState } from "react";
import { FieldsLayout } from "./layout";
import FieldMappingsContent from "./mappings-content";

const FieldMappingsPage = () => {
  const [refreshFn, setRefreshFn] = useState<(() => Promise<void>) | undefined>();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefreshReady = (fn: () => Promise<void>, refreshing: boolean) => {
    setRefreshFn(() => fn);
    setIsRefreshing(refreshing);
  };

  return (
    <FieldsLayout onRefresh={refreshFn} isRefreshing={isRefreshing}>
      <FieldMappingsContent onRefreshReady={handleRefreshReady} />
    </FieldsLayout>
  );
};

export default FieldMappingsPage;
